import axios from '@/utils/axiosHelper';

// 初始化数据(含授权)
export const onGetInitDataAPI = (params) => {
  return axios({ url: '/sword/solider/init', method: 'GET', params }, { interceptResultCode: false });
};
// 刷新信息
export const onRenovateAPI = () => {
  return axios({ url: '/sword/solider/renovate', method: 'GET' });
};

// 拜师
export const onRecruitAPI = (data) => {
  return axios({ url: '/sword/solider/recruit', method: 'POST', data });
};

// 完成每日任务
export const completeTakeAPI = (data) => {
  return axios({ url: '/sword/solider/complete/task', method: 'POST', data });
};

// 桃李商店列表
export const getShopListAPI = () => {
  return axios({ url: '/sword/solider/shop/list', method: 'GET' });
};

// 桃李商店兑换
export const onExchangeAPI = (data) => {
  return axios({ url: '/sword/solider/shop/send', method: 'POST', data });
};

// 查看考核
export const getExaminesAPI = (params) => {
  return axios({ url: '/sword/solider/look', method: 'GET', params });
};

// 领取桃李值
export const onReceiveScoreAPI = (data) => {
  return axios({ url: '/sword/solider/draw/score', method: 'POST', data });
};

// 师徒关系
export const onMasterListAPI = () => {
  return axios({ url: '/sword/solider/master/list', method: 'GET' });
};

// 逐出师门
export const onDriveAPI = (data) => {
  return axios({ url: '/sword/solider/master/drive', method: 'POST', data });
};

// 判出师门
export const onBetrayAPI = (data) => {
  return axios({ url: '/sword/solider/master/betray', method: 'POST', data });
};

// 消息列表
export const getNewListAPI = () => {
  return axios({ url: '/sword/solider/check/index ', method: 'GET' });
};

// 同意|拒绝 申请
export const onCheckNoticeAPI = (data) => {
  return axios({ url: '/sword/solider/check/notice', method: 'POST', data });
};

// 通过用户id查询角色
export const findRoleInfoAPI = (data) => {
  return axios({ url: '/sword/solider/check/rid', method: 'POST', data });
};

// 信息提交(id搜索拜师、收徒用的)
export const sendCheckStore = (data) => {
  return axios({ url: '/sword/solider/check/store', method: 'POST', data });
};

// 通过code+id查询用户信息   
export const getUserInfoByCodeId = (data) => {
  return axios({ url: '/sword/solider/check/info', method: 'POST', data });
};




// WEBPACK FOOTER //
// ./src/pages/hjwq/mentoring/api.js